
import { defineComponent, reactive, toRefs, watch } from "vue";
import { IMenu } from "@/types/types";
import {useRoute} from "vue-router"
// import { useRoute } from "vue-router";

export default defineComponent({
  name: "",
  components: {},
  setup() {
    //*********** definning variables start **********//
    interface IRawData {
      menu: IMenu[];
      defalutNav:string
    }
    const rawData = reactive<IRawData>({
      menu: [
        // { id: 1, title: "个人中心", path: "/profile", icon: "" },
        { id: 2, title: "资料完善", path: "/complete", icon: "el-icon-user" },
        { id: 3, title: "专业确认", path: "/major", icon: "el-icon-position" },
        { id: 4, title: "缴费记录", path: "/pay", icon: "el-icon-coordinate" },
        { id: 5, title: "准考证", path: "/ticket", icon: "el-icon-postcard" },
        { id: 6, title: "录取查询", path: "/search", icon: "el-icon-search" },
        { id: 7, title: "修改密码", path: "/change_password", icon: "el-icon-unlock" },
      ],
      defalutNav:'/complete'
    });
    const route = useRoute()


    //*********** definning variables end **********//

    //*********** initData start **********//
    watch(()=>route.path,()=>{
      rawData.defalutNav = route.path
    })

    if(route.path){
      rawData.defalutNav = route.path
    }

    //*********** initData end **********//

    //*********** format start **********//

    //*********** format end **********//

    //*********** Data FUN start **********//

    //*********** Data FUN end **********//

    //*********** DOM FUN start **********//
    return {
      ...toRefs(rawData),
    };
    //*********** DOM FUN end **********//
  },
});
